import React ,{useEffect} from 'react';
import {useNavigate} from 'react-router';
import CustomTable from '../../../components/CustomTable';
import {column} from './column';
import {getConsumableMasterNew} from '../../../@app/subMaster/subMasterSlice';
 import {useDispatch, useSelector } from 'react-redux';

export default function ConsumableMaster({setTopTitle}) {
  setTopTitle('Consumable Master Details');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onClickAdd = () => {
    navigate('/consumableMasterNew/addForm', {
      state: {}
    });
  };

  const handleDownload = () => {
    window.open(
      process.env.REACT_APP_API_BASE_URL + "download-consumable-master-upload",
      "_blank"
    );
  };

  const onClickUpdateCsv = () => {
    navigate("/consumableMasterNew/csvUpdate", {
      state: {}
    });
  };

   const handleEditClick = async (data) => { 
    console.log(data,'data');
      navigate("/consumableMasterNew/editForm", {
            state: { data, ...data }
        });   
  };

  const { type, userData } = useSelector((state) => state.auth);
  useEffect(() => {
    if (type === 1)
      dispatch(getConsumableMasterNew({ path: "get-Consumable-Master-New", data: {} }));
    else
      dispatch(
        getConsumableMasterNew({
          path: "get-Consumable-Master-New",
          data: { employee: userData.data?.id }
        })
      );
  }, []);
 

  const {
    gettingConsumableMasterNew,
    getConsumableMasterNewResponse: {data: dataSource}
  } = useSelector((state) => {
    return state.subMaster;
  });

  return (
    <CustomTable
      loading={gettingConsumableMasterNew}
      dataSource={dataSource}
      column={column}    
      handleEditClick={handleEditClick}
      onClickAdd={onClickAdd}
      title={"Consumable Master Details"}       
    //  hideActionBtn={true}    
      handleDownload={handleDownload}
      onClickUpdateCsv={onClickUpdateCsv}  
    />
  );
}
